import { render, staticRenderFns } from "./ExploreCategoryBadge.vue?vue&type=template&id=14c0748f&scoped=true&"
import script from "./ExploreCategoryBadge.vue?vue&type=script&lang=js&"
export * from "./ExploreCategoryBadge.vue?vue&type=script&lang=js&"
import style0 from "./ExploreCategoryBadge.vue?vue&type=style&index=0&id=14c0748f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c0748f",
  null
  
)

export default component.exports